export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/ascending.js
// module id = 5
// module chunks = 0